module.exports = __webpack_public_path__ + "static/media/back-pattern.628fa1f9.png";